import { all, fork } from 'redux-saga/effects';
import { salesSagaWatcher } from './salesSaga';
import { createRuleSagaWatcher } from './createRuleSaga';
import { eventTrackSagaWatcher } from './eventTrackSaga';
import fullCompanyViewWatcher from './fullCompanyView';
import itemDrillDownSagaWatcher from './itemDrillDown';
import { customTableSagaWatcher } from './columnTableSaga';
import { appGuideSagaWatcher } from './appGuideSaga';
import guidedInsightsWatcher from './graphql/guidedInsights/index'

export default function* rootSaga() {
	yield all([
		fork(salesSagaWatcher),
		fork(createRuleSagaWatcher),
		fork(eventTrackSagaWatcher),
		fork(fullCompanyViewWatcher),
		fork(itemDrillDownSagaWatcher),
		fork(customTableSagaWatcher),
		fork(appGuideSagaWatcher),
		fork(guidedInsightsWatcher)
	]);
}
